"use strict";import{tag as e}from"../custom-tag.js";export function uploadIcon({height:l=16,width:a=16,hidden:t=!1,title:r="Upload"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${a}
      height=${l}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <mask
        id="upload_svg__mask0_6875_6272"
        width="20"
        height="21"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M20.824 10.752v9.998H3.176v-9.998H2v10.623a.66.66 0 0 0 .172.442.6.6 0 0 0 .416.183h18.824a.56.56 0 0 0 .416-.183.66.66 0 0 0 .172-.442V10.752z"
        />
        <path
          fill="currentColor"
          d="M11.397 4.065v10.438h1.176V4.046l3.54 3.453.795-.922-4.526-4.413a.57.57 0 0 0-.4-.164.57.57 0 0 0-.399.168L7.141 6.585l.804.914z"
        />
      </mask>
      <g mask="url(#upload_svg__mask0_6875_6272)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=upload.js.map
